<template>
  <div>
    <b-card-body>
      <b-card class="importContainer">
        <b-form-group>
          <div class="table-container">
            <table class="definir-metas-table">
              <thead>
                <tr>
                  <th>Variável</th>
                  <th>Referência Plano de safra</th>
                  <th>Referência manual</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(meta, idx) in localMetaSettings" :key="idx">
                  <td>{{ meta.variable }}</td>
                  <td class="option-select">
                    <input
                      class="cursor"
                      type="radio"
                      :name="'metaOption-' + idx"
                      value="pgdi"
                      v-model="localMetaSettings[idx].metaSource"
                    />
                  </td>
                  <td class="option-select">
                    <input
                      class="cursor"
                      type="radio"
                      :name="'metaOption-' + idx"
                      value="manual"
                      v-model="localMetaSettings[idx].metaSource"
                    />
                    <input
                      v-if="localMetaSettings[idx].metaSource === 'manual'"
                      type="text"
                      v-model="localMetaSettings[idx].manualValue"
                      class="manual-input ml-1"
                      placeholder="Digite a Meta"
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </b-form-group>
        <b-row class="groupBtn">
          <div class="modal-buttons">
            <img
              class="action-btn"
              width="30"
              height="30"
              src="@/assets/salvar.png"
              :title="$t('salvar')"
              @click="onSave"
            />
            <img
              class="action-btn ml-2 exit-btn"
              width="30"
              height="30"
              src="@/assets/sair.png"
              :title="$t('cancelar')"
              @click="onClose"
            />
          </div>
        </b-row>
      </b-card>
    </b-card-body>
  </div>
</template>

<script>
export default {
  name: "GoalModal",
  props: {
    metaSettings: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      // Cria uma cópia local para manipulação sem afetar diretamente a prop
      localMetaSettings: JSON.parse(JSON.stringify(this.metaSettings))
    };
  },
  methods: {
    onSave() {
      // Emite os dados atualizados para o componente pai
      this.$emit("save", this.localMetaSettings);
    },
    onClose() {
      this.$emit("close");
    }
  },
  watch: {
    metaSettings(newVal) {
      this.localMetaSettings = JSON.parse(JSON.stringify(newVal));
    }
  }
};
</script>

<style scoped>
.modal-title {
  text-align: center;
  margin-bottom: 15px;
  font-size: 18px;
}
/* Container com rolagem para a tabela se ultrapassar 6 linhas */
.table-container {
  max-height: 400px; /* Ajuste conforme necessário */
  overflow-y: auto;
}
.definir-metas-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 10px;
}
.definir-metas-table th,
.definir-metas-table td {
  border: 1px solid #ccc;
  padding: 8px;
  text-align: center;
  font-size: 14px;
}
.definir-metas-table th {
  background: #f5f5f5;
}
.manual-input {
  margin-top: 5px;
  width: 95px;
  padding: 4px;
  border: 1px solid #ccc;
  font-size: 14px;
  outline: none;
}
.groupBtn {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
}
.modal-buttons {
  margin-top: 10px;
  text-align: right;
  cursor: pointer;
}
.action-btn {
  border: none;
  background: transparent;
  cursor: pointer;
}

.exit-btn {
  margin-left: 14px;
  margin-right: 14px;
}

.cursor 
{
  cursor: pointer;
}

.option-select input[type="radio"] {
    accent-color: #009a9a;
    cursor: pointer;
}
</style>
